<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 pdb-0">
      <a @click="$emit('toggleSelection')">
        <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
      </a>
      <span class="mgl-10px has-text-weight-bold is-size-4">
        {{$t('selectionProduit.title')}}
      </span>
    </div>
    <div class="column is-12 pdb-0 border-entete">
      <span class="mgl-10px has-text-icon-more is-size-7">
        {{ $t('selectionProduit.sousTitle', { nbrProduit: selectionGetter.length }) }}
      </span>
    </div>
    <div
      v-if="selectionGetter.length > 0"
      class="column is-12-tablet hauteur-panier is-marginless">
      <div class="overflow-auto">
        <display-produit-in-selection
          :selection="newSelections"
          :title="newSelections.length > 0 ? $t('selectionProduit.newSelection') : ''"
          :info="newSelections.length > 0
            ? '' : $t('selectionProduit.' + (forSelectionFaceOnly ? 'noNewFace' : 'noNewProduit'))"
          :isAlreadySelect="false"
          :storeName="storeName"
          :forSelectionFaceOnly="forSelectionFaceOnly">
        </display-produit-in-selection>
        <display-produit-in-selection
          v-if="oldSelections.length > 0"
          :selection="oldSelections"
          :title="$t('selectionProduit.' + (forSelectionFaceOnly
            ? 'produitFromReseau' : 'produitFromSelection'))"
          :isAlreadySelect="true"
          :storeName="storeName"
          :forSelectionFaceOnly="forSelectionFaceOnly"
          class="mgt-20px">
        </display-produit-in-selection>
      </div>
    </div>
    <div v-else class="column is-12 hauteur-panier is-flex">
      <div class="has-text-centered mg-auto">
        <div class="logo__panier_vide mg-auto"></div>
        <p class="has-text-weight-bold is-size-5">
          {{$t('selectionProduit.panierVide')}}
        </p>
        <p>{{$t('selectionProduit.' + (forSelectionFaceOnly ? 'noFace' : 'noProduit'))}}</p>
      </div>
    </div>
    <div class="column is-12 hauteur-bas-panier border-pied columns is-marginless is-vcentered">
      <button
        @click="$emit('ajoutProduitsSelectionnes')"
        :class="[
          {'is-select pointer-events-none': selectionGetter.length === 0},
          {'is-addOrEdit': selectionGetter.length > 0}
        ]"
        class="button pdv-0 column is-narrow pdh-20px is-pulled-right">
        {{$t('general.button.add')}}
      </button>
    </div>
  </div>
</template>

<script>
import displayProduitInSelection from '@/components/catalogue/selectionProduit/displayProduitInSelection';

export default {
  components: {
    displayProduitInSelection,
  },
  props: {
    storeName: {
      type: String,
      default: 'produitFace',
    },
    forSelectionFaceOnly: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selectionGetter() {
      return this.$store.getters[`${this.storeName}/panier`];
    },
    newSelections() {
      this.$store.dispatch(`${this.storeName}/loadLogoPanier`, false);
      return this.selectionGetter.filter((produit) => { return !produit.isAlreadySelect; });
    },
    oldSelections() {
      this.$store.dispatch(`${this.storeName}/loadLogoPanier`, false);
      return this.selectionGetter.filter((produit) => { return produit.isAlreadySelect; });
    },
  },
};
</script>
